import http from '../http'
import url from './index-url'
const { get, post } = http

export default {
  getPolyvToken(data) {
    return get(url.getPolyvToken(), data)
  },
  getQuesstionInfo(data) {
    return get(url.getQuesstionInfo(), data)
  },
  insinfo(data) {
    return get(url.insinfo(), data)
  },
  viewVideo(data) {
    return post(url.viewVideo(), data)
  },
  getNewQuesstionInfo(data) {
    return get(url.getNewQuesstionInfo(), data)
  },
  getGaopinSign(data) {
    return get(url.getGaopinSign(), data)
  },
  getAliToken(data) {
    return get(url.getAliToken(), data)
  }
}